module.exports = __webpack_public_path__ + "img/TECHNOLOGY-ERTIGA-BOOSTER-GREEN-1.0aa70874.jpg";